import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('werner_token');
    if (token) {
      api.get('/auth/verify', { timeout: 8000 })
        .then(() => setIsAuthenticated(true))
        .catch((err) => {
          // Only clear token on explicit 401 — not on network/timeout errors
          if (err.response?.status === 401) {
            localStorage.removeItem('werner_token');
          }
          setIsAuthenticated(err.response?.status !== 401);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback((token) => {
    localStorage.setItem('werner_token', token);
    setIsAuthenticated(true);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('werner_token');
    setIsAuthenticated(false);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
